module.exports = __webpack_public_path__ + "components/country-flag/static/mg-86c1173d11a96f70ac7620c6c25c8ecf.svg";